const META_PIXEL_ID = String(import.meta.env.VITE_META_PIXEL_ID || '').trim();

function canTrack() {
  return typeof window !== 'undefined' && Boolean(META_PIXEL_ID);
}

/** Load Meta (Facebook) Pixel once and fire PageView. */
export function initMetaPixel() {
  if (!canTrack() || window.__invincibleMetaPixelInitialized) return;
  window.__invincibleMetaPixelInitialized = true;

  /* eslint-disable prefer-rest-params, no-unused-expressions */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable prefer-rest-params, no-unused-expressions */

  window.fbq('init', META_PIXEL_ID);
  window.fbq('track', 'PageView');
}

/** SPA route change — Meta treats this as another PageView. */
export function trackMetaPageView() {
  if (!canTrack() || typeof window.fbq !== 'function') return;
  window.fbq('track', 'PageView');
}

/** Standard Meta events (Lead, Purchase, etc.). */
export function trackMetaEvent(eventName, params) {
  if (!canTrack() || typeof window.fbq !== 'function') return;
  if (params && typeof params === 'object') {
    window.fbq('track', eventName, params);
  } else {
    window.fbq('track', eventName);
  }
}

export function getMetaPixelId() {
  return META_PIXEL_ID || null;
}
